export function bigIntMin(a: bigint, b: bigint): bigint {
  return b < a ? b : a;
}

export function bigIntMax(a: bigint, b: bigint): bigint {
  return b > a ? b : a;
}
